import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation createNpsMutation($input: CreateNpsInput!) {
		createNps(input: $input) {
			clientMutationId
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const {score, type} = input;
	if (type !== 'NPS_NEW ' && type !== 'NPS_EMOJI') {
		tracking.trackEvent('NPS answered', {score, type});
	}
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
